function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_2340_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1551_",
  d: "m10 454h492v48h-492z",
  fill: "#cfd3df"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1550_",
  d: "m40 56h432v398h-432z",
  fill: "#f2cd69"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1549_",
  d: "m256 312c-39.765 0-72 32.236-72 72v70h144v-70c0-39.764-32.236-72-72-72z",
  fill: "#c7ebfa"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1548_",
  d: "m123.667 10h264.667v46h-264.667z",
  fill: "#f6da8f"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#cbf4fb"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1994_",
  d: "m88 120h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1993_",
  d: "m184 120h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1992_",
  d: "m280 120h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1991_",
  d: "m376 120h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1990_",
  d: "m88 216h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1989_",
  d: "m184 216h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1988_",
  d: "m280 216h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1987_",
  d: "m376 216h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1986_",
  d: "m88 312h48v48h-48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1985_",
  d: "m376 312h48v48h-48z"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_630_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_631_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_806_",
  d: "m502 444h-20v-388c0-5.523-4.478-10-10-10h-73.667v-36c0-5.523-4.478-10-10-10h-264.666c-5.522 0-10 4.477-10 10v36h-73.667c-5.522 0-10 4.477-10 10v388h-20c-5.523 0-10 4.477-10 10v48c0 5.523 4.477 10 10 10h201.004c5.522 0 10-4.477 10-10s-4.478-10-10-10h-191.004v-28h472v28h-191.002c-5.522 0-10 4.477-10 10s4.478 10 10 10h201.002c5.522 0 10-4.477 10-10v-48c0-5.523-4.478-10-10-10zm-368.333-424h244.666v26h-244.666zm112.333 424h-52v-60c0-30.782 22.553-56.385 52-61.182zm20 0v-121.182c29.447 4.797 52 30.4 52 61.182v60zm72 0v-60c0-45.215-36.785-82-82-82s-82 36.785-82 82v60h-124v-378h412v378z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_825_",
  d: "m136 110h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_828_",
  d: "m232 110h-48c-5.523 0-10 4.477-10 10v48c0 5.523 4.477 10 10 10h48c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_831_",
  d: "m328 110h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.522 0 10-4.477 10-10v-48c0-5.523-4.478-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_834_",
  d: "m424 110h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.522 0 10-4.477 10-10v-48c0-5.523-4.478-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1471_",
  d: "m136 206h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1482_",
  d: "m232 206h-48c-5.523 0-10 4.477-10 10v48c0 5.523 4.477 10 10 10h48c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1487_",
  d: "m328 206h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.522 0 10-4.477 10-10v-48c0-5.523-4.478-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1490_",
  d: "m424 206h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.522 0 10-4.477 10-10v-48c0-5.523-4.478-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_632_",
  d: "m136 302h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1513_",
  d: "m424 302h-48c-5.522 0-10 4.477-10 10v48c0 5.523 4.478 10 10 10h48c5.522 0 10-4.477 10-10v-48c0-5.523-4.478-10-10-10zm-10 48h-28v-28h28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1522_",
  d: "m256 492c-2.63 0-5.21 1.07-7.07 2.93s-2.93 4.44-2.93 7.07 1.069 5.21 2.93 7.07c1.86 1.86 4.44 2.93 7.07 2.93s5.21-1.07 7.069-2.93c1.86-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07c-1.859-1.86-4.439-2.93-7.069-2.93z"
}))));

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.cc6ea8a1.svg";
export { ForwardRef as ReactComponent };